import { SVerificationCode } from './VerificationCode.styles';
import { VerificationCodeProps } from './VerificationCode.types';

export const VerificationCode = ({ ...props }: VerificationCodeProps) => {
  return <SVerificationCode {...props} />;
};
